module.exports = __webpack_public_path__ + "img/talk-radio.98263737.png";